import React from 'react';
import { Star } from 'lucide-react';

export default function ReferencePageBadge({ className = '', compact = false }) {
  return (
    <span
      className={`inline-flex items-center gap-0.5 shrink-0 font-medium text-accent bg-accent/10 border border-accent/25 rounded-full ${
        compact ? 'text-[10px] px-1.5 py-0' : 'text-[10px] px-2 py-0.5'
      } ${className}`}
      title="Page de référence"
    >
      <Star size={compact ? 10 : 11} className="fill-accent/30" aria-hidden />
      Réf.
    </span>
  );
}
